// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gallerybox_container {\r\n}\r\n.gallerybox_bar {\r\n  background-color: #f05a25;\r\n  color: #fff;\r\n  height: 15%;\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 10px;\r\n  margin-top: -5px;\r\n}\r\n.gallerybox_bar > p {\r\n  font-size: 2vw !important;\r\n}\r\n.gallerybox_iconcontainer > img{\r\n  height: 6vh;\r\n  width: 3.5vw;\r\n}\r\n.gallerybox_iconcontainer {\r\n  margin-right: 20px;\r\n}", ""]);
// Exports
module.exports = exports;
